import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { RoleFindInterface } from '@zaoblako/shared/modules/security/dtos/role/role-find.dto';

import * as yup from 'yup';

/** Company group creation body */
export interface CompanyGroupFormInterface {
  /** Company group display name */
  name: string;
  /** Roles of users who have access to companies from this group */
  roles?: RoleFindInterface[];
  /** Companies in this group */
  companies: CompanyFindInterface[];
}

/** Company group creation body - DTO Schema */
export const CompanyGroupFormDto = SerdeDtoClass.create<CompanyGroupFormInterface>(ClientDtoKeysEnum.COMPANY_GROUP_FORM_DTO, {
  name: {
    label: 'Имя',
    serializer: yup.string().required(DtoMessageEnum.EMPTY_STRING),
  },
  roles: {
    optional: true,
    label: 'Роли',
    serializer: yup.array(entityLikeSchema),
  },
  companies: {
    label: 'Компании',
    serializer: yup.array(entityLikeSchema),
  },
});
